<template>
    <div>
        <Pagesubtitle  subTitle="Send bulk feedback invites via email." />
        <vs-tabs v-model="currentTab">
            <vs-tab label="Send Invites" class="nofilterimags px-0">
                <SendEmailinvites/>
            </vs-tab>
            <vs-tab label="Auto Followups" class="nofilterimags px-0">
                <EmailFollowup/>
            </vs-tab>
            <vs-tab label="Invite History" class="nofilterimags px-0">
                <InviteHistory/>
            </vs-tab>
        </vs-tabs>
    </div>
</template>

<script>

import Pagesubtitle from '../components/ptcomponents/Pagesubtitle.vue'
import SendEmailinvites from './SendEmailinvites.vue'
import EmailFollowup from './EmailFollowup.vue'
import InviteHistory from './InviteHistory.vue'

export default {
    data() {
        return {
            currentTab: 0
        }
    },
    components: {
        SendEmailinvites,
        Pagesubtitle,
        EmailFollowup,
        InviteHistory
    }
}

</script>